import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="32" fill="none" viewBox="0 0 27 32">
      <path
        fill="#828FA1"
        fillRule="evenodd"
        d="M0 8.56v15.237l13.024 7.62 13.021-7.62V8.56L13.024.941 0 8.561zm1.146 14.57V9.23L13.024 2.28 24.903 9.23V23.13l-11.879 6.95-11.878-6.95z"
        clipRule="evenodd"
      />
      <path
        fill="#828FA1"
        fillRule="evenodd"
        d="M18.128 7.52H7.894l-1.186 5.287h12.653L18.128 7.52zM9.71 20.083V16.57l-3.032-1.953-3.43 2.584 4.676 8.24h1.868L12 23.357V22.31L9.71 20.083z"
        clipRule="evenodd"
      />
      <path
        fill="#828FA1"
        fillRule="evenodd"
        d="M16.348 13.604H9.72l1.116 2.954-.34 3.31h2.526l2.55-.012-.318-3.298 1.093-2.954z"
        clipRule="evenodd"
      />
      <path
        fill="#828FA1"
        fillRule="evenodd"
        d="M19.379 14.593l-2.996 1.977v3.513l-2.29 2.227v1.047l2.208 2.06h1.844l4.653-8.216-3.419-2.608z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export default Icon
